import * as React from "react";
import { CSVLink } from "react-csv"
import { Button, Input, InputRef, PaginationProps, Row, Space, Table } from "antd";
import { Key, useRef, useState } from "react";
import { ColumnsType, ColumnType, FilterConfirmProps, FilterValue } from "antd/lib/table/interface";
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { DATE_INPUT, USAGEGROUPUPDATE_ACTION_STATE_KEY, USAGE_MATCHSTATUS_DEFINITE_MATCH } from "../../Consts";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { IAgreementWorkDataItems } from "../../types/IAgreementWorkDataItems";
import { IRepertoireField } from "../../types/IRepertoireField";
import { createCopyOfTableContents } from "../../services/TableFunctions";
import { ComponentsHelper } from "../../../core/services/ComponentHelper";
import { IInterestedPartySearchResultRowType } from "../../types/IInterestedPartySearchResultRowType";
import { IUsageSearchResultRowType } from "../../types/usageTypes/IUsageGroupsSearchResult";
import { IIPsSearchQuery } from "../../types/IIPsSearchQuery";
import { EXTERNAL_BLACK_SVG } from "../../IconConsts";
import { Select } from "antd";
import { ILookupInstance } from "../../../lookup/types/ILookup";
import { ILookupOptionsAndOnChangeFunctions, IRowActions } from "../../../membersportal/sharedComponents/displayTable/DisplayTable";
import IconTextButton from "../iconTextButton/IconTextButton";
import DropdownDataInput from "../dropdownDataInput/DropdownDataInput";
import TimeDataInputWrapper from "../timeFieldDataInput/TimeDataInputWrapper";
import SizedDateDataInput from "../../../repertoire/components/dateDataInput/DateDataInput";
import DisplayDate from "../text/DisplayDate";
import { IApplicableWorkSearchQuery } from "../../types/IApplicableWorkSearchQuery";
import { DataSource } from "../../types/DataSource";
import { Delete20Regular } from "@fluentui/react-icons";

export interface IResultsTableProps {
    onChange?: (dropDownValue: string | boolean | string[], name: string, rowIndex: number) => void;
    searchResultsTableData: IRepertoireField[];
    tableContents?: any;
    componentInstance?: string;
    selectAll?: boolean;
    isSelectedAll?: boolean;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    repertoireSection?: string;
    sortSearchResults?: (name: string, results: any) => void;
    changeData?: (value: any, fieldName: string) => void;
    search: (continuationToken?: string) => void;
    continuationToken?: string;
    showFieldsModal?: (componentFieldName: string) => void;
    saveResultData?: IRepertoireComponentDataItem;
    resetMessageBanner?: () => void;
    isHundredResultsPerPage?: boolean;
    setIsHundredResultsPerPage?: (isHundredResultsPerPage: boolean) => void;
    onClickOpen?: (tableContentItem: IAgreementWorkDataItems) => void;
    titleContains?: string;
    updateContentsTabl?: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    searchResults?: IAgreementWorkDataItems[];
    skip?: number;
    resetPagination?: (repertoireSection: string) => void;
    updateContentsTable: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    lookupOptionsAndOnChangeFunctions?: ILookupOptionsAndOnChangeFunctions;
    removeRowAction?: (item: IAgreementWorkDataItems) => void;
    isLinkTitle?: boolean;
    rowActions?: IRowActions;
    getApplicableWorkDetails?: (applicableWork:IApplicableWorkSearchQuery,isSearched:boolean) => void;
    entityID?: number;
    entitySource?: DataSource;
    agreementsallWorks?: IAgreementWorkDataItems[];
    isReadonly?: boolean;
}


type DataIndex = keyof IAgreementWorkDataItems;

export const ResultsTable: React.FC<IResultsTableProps> = (props: IResultsTableProps) => {

    const [selectedRows, setSelectedRows] = useState<IAgreementWorkDataItems[]>([]);
    const [updatedUsageGroups, setUpdatedUsageGroups] = useState<IAgreementWorkDataItems[]>([]);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [showMoreRows, setShowMoreRows] = useState<number[]>([]);
    const [hasChanges, setHasChanges] = useState<number[]>([]);
    const [showMoreAll, setShowMoreAll] = useState<boolean>(true);
    const searchInput = useRef<InputRef>(null);
    const [expandedRows, setExpandedRows] = useState<Key[]>([]);
    const [allExpanded, setAllExpanded] = useState<boolean>(false);
    const [currentTableData, setCurrentTableData] = React.useState([]);
    const [oldSorted, setOldSorter] = useState({});
    const [currentPageNumberTable, setCurrentPageNumberTable] = useState<number>(props.currentPage);
    const [queryParams, setQueryParams] = React.useState({
        ipNumber: '',
        fullName: '',
        accountNumber: '',
        interestedPartyType: ''
    });
    const [filteredData, setFilteredData] = useState<IAgreementWorkDataItems[]>([]);
    const [isSearching, setIsSearching] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(props.resultsPerPage);
    const [searchWorkName, setWorkName] = useState('');
    const [searchWorkNumber, setWorkNumber] = useState('');
    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        const searchValue = selectedKeys[0];
        setIsSearching(true);
        setSearchText(searchValue);
        setSearchedColumn(dataIndex);
         if (searchValue != undefined) {
             let filteredWorks: IAgreementWorkDataItems[] = [];
             const searchLower = searchValue.toLowerCase();
             let workName = searchWorkName;
             let workNumber = searchWorkNumber;
             if (dataIndex === "workName") {
                 workName = searchLower;
                 setWorkName(searchLower);
             }
             else if (dataIndex === "workNumber") {
                 workNumber = searchLower;
                 setWorkNumber(searchLower);
             }
             const agreementData: IApplicableWorkSearchQuery = {
                 agreementID: props.entityID,
                 workNumber: workNumber,
                 page: currentPage,
                 workName: workName,
                 pageSize: 1000,
                 currentUserNameNumber: "",
                 dataSource: props.entitySource
             };

             props.getApplicableWorkDetails(agreementData,true);

         }
         else {
            setIsSearching(false);
            setFilteredData(tableContents);
         }
        confirm();
    };

    const handleReset = (
        clearFilters: () => void,
        confirm?: (param?: FilterConfirmProps) => void
    ) => {
        clearFilters();

        setSearchText('');
        setSearchedColumn('');
        setWorkName('');
        setWorkNumber('');

        if (!isSearching) {
            confirm?.();
            return;
        }

        setIsSearching(false);
        confirm?.();
    };

    const isSortingChanged = (sorter) => {
        return JSON.stringify(sorter) !== JSON.stringify(oldSorted);
    }
    const handleChange = (pagination, filters: globalThis.Record<string, FilterValue>, sorter) => {
        if (filters.title && props.titleContains !== filters.title.toString()) {
            props.changeData(filters.title.toString(), 'title');
        }
        
        if (isSortingChanged(sorter)) {
            setCurrentPageNumberTable(1);
        } else {
            setCurrentPageNumberTable(pagination.current);
        }
    
        setOldSorter(sorter)
        sortTableByColumn(sorter)
    }
    
    const { tableContents, skip,agreementsallWorks } = props;


    React.useEffect(() => {
        const sourceData = isSearching && agreementsallWorks?.length ? agreementsallWorks : tableContents || [];

        const data: IAgreementWorkDataItems[] = sourceData.map((row, idx) => ({
            rowIndex: idx,
            agreementID: row.agreementID,
            agreementWorkID: row.agreementWorkID,
            workID: row.workID,
            workName: row.workName,
            workNumber: row.workNumber,
            type: row.type,
            exclusionUntil: row.exclusionUntil,
            excludedUntilDate: row.excludedUntilDate,
            worksRetainedUntil: row.worksRetainedUntil,
            workRetentionEndDate: row.workRetentionEndDate,
            useDefaultCollection: row.useDefaultCollection,
            workCollectionUntil: row.workCollectionUntil,
            workCollectionEndDate: row.workCollectionEndDate,
            recipientWorkNumber: row.recipientWorkNumber,
            recipientWorkNumberOwner: row.recipientWorkNumberOwner,
            useDefaultRetention: row.useDefaultRetention
        }));

        setFilteredData(data);
    }, [tableContents, agreementsallWorks, isSearching]);

    const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<IAgreementWorkDataItems> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={(e) => {
                        const value = (e.target as HTMLInputElement).value;
                        setSelectedKeys(value ? [value] : []);
                        handleSearch([value], confirm, dataIndex);
                    }}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, confirm)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText((selectedKeys as string[])[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button type="link" size="small" onClick={() => { close(); }}>
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#fcfa5d', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });
    const sortTableByColumn = (sorter: any) => {
        const { componentInstance, sortSearchResults, tableContents } = props;
        let descending = sorter.order === "ascend" ? false : true;

        const tableContentsCopy = createCopyOfTableContents(tableContents);

        tableContentsCopy.sort((a: any, b: any) => {
            // set to emtpy string if null
            let newA = sorter.field == 'sourceMajor' ? a['source'] || "" : a[sorter.field] || "";
            let newB = sorter.field == 'sourceMajor' ? b['source'] || "" : b[sorter.field] || "";

            newA = newA ? newA : "";
            newB = newB ? newB : "";

            if (!descending) {
                return isNaN(newA) ? (newA > newB ? 1 : -1) : (newA - newB);
            } else {
                return isNaN(newA) ? (newB > newA ? 1 : -1) : (newB - newA);
            }
        });

        if (sortSearchResults) {
            sortSearchResults(componentInstance, tableContentsCopy);
        }
    };
  
    const getColumns = () => {
        const {
            searchResultsTableData,
            tableContents,
            lookupOptionsAndOnChangeFunctions,
            onClickOpen,
            removeRowAction,
            onChange,
            isLinkTitle,
            rowActions,
            isReadonly
        } = props;

        const removeRow = (item: IAgreementWorkDataItems) => {
            if (removeRowAction) {
                removeRowAction(item);
            }
        };
    
        const searchResults = tableContents;
        let removedItemAction: IRepertoireField = undefined;
    
        if (!searchResultsTableData) return [];
    
        let orderedFields = ComponentsHelper.orderFieldsBySpecificField(searchResultsTableData, "order");
        if (!orderedFields || orderedFields.length === 0) {
            orderedFields = searchResultsTableData;
        }
    
        if (removedItemAction) {
            orderedFields.push(removedItemAction);
        }
    
        const columns: ColumnsType<IAgreementWorkDataItems> = orderedFields.map(field => {
            const isDateCellAgreementWorks =
                field.fieldType === DATE_INPUT &&
                (field.name === 'excludedUntilDate'
                    || field.name === 'workRetentionEndDate'
                    || field.name === 'workCollectionEndDate');
    
            const options = lookupOptionsAndOnChangeFunctions?.[field.name]?.options || [];
            const onChangeValue = lookupOptionsAndOnChangeFunctions?.[field.name]?.onChangeValue;
            const showLinkedTitleInPlaceOfNavigationIcon = isLinkTitle && ( field.name === 'workName');
            const isDateCell = field.fieldType === DATE_INPUT;
            const onChangeDate = lookupOptionsAndOnChangeFunctions['excludedUntilDate'].onChangeValue;
            const onChangeType = lookupOptionsAndOnChangeFunctions['type'].onChangeValue;
            switch (field.name) {
                case 'workName':

                    return {
                        title: field.data,
                        dataIndex: field.name,
                        width: '15em',
                        sorter: (a, b) =>
                            a.workName?.value && b.workName?.value
                                ? a.workName.value.localeCompare(b.workName.value)
                                : 0,
                        key: field.name,
                        ...getColumnSearchProps(field.name as keyof IAgreementWorkDataItems), 
                        render: (value, record, index) => value !== null ?
                            <div>
                                 <a onClick={() => rowActions.iconButton.onClick(record)}>{record[field.name].value}</a>
                            </div> : null
                    }
                case 'workNumber':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        width: '15em',
                        sorter: (a, b) =>
                            a.workNumber?.value && b.workNumber?.value
                                ? a.workNumber.value.localeCompare(b.workNumber.value)
                                : 0,
                        key: field.name,
                        ...getColumnSearchProps(field.name as keyof IAgreementWorkDataItems), 
                        render: (value, record, index) => value !== null ?
                            <div>
                                {record[field.name].value}
                            </div> : null
                    }
                case 'type':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.type?.value && b.type?.value
                                ? a.type.value.localeCompare(b.type.value)
                                : 0,
                        key: field.name,
                        render: (value, record, index) => value !== null ?
                                    <DropdownDataInput
                                        value={record[field.name].value}
                                        fieldName={field.name}
                                        options={null}
                                        changeData={value => onChangeType(value, field.name, record.rowIndex)}
                                        allowNull={true}
                                        readOnly={true}
                                        isHidden={false}
                                    /> : null
                    }
                
                case 'exclusionUntil':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.exclusionUntil?.value && b.exclusionUntil?.value
                                ? a.exclusionUntil.value.localeCompare(b.exclusionUntil.value)
                                : 0,
                        key: field.name,
                        render: (value, record, index) => value !== null ?
                        <DropdownDataInput
                                value={record[field.name].value}
                                fieldName={field.name}
                                options={options}
                                changeData={value => lookupOptionsAndOnChangeFunctions['exclusionUntil'].onChangeValue(value, field.name, record.rowIndex)}
                                allowNull={true}
                                useComboBoxAsMenuWidth={false}
                                isHidden={false}
                                readOnly={isReadonly !== undefined ? isReadonly : undefined}
                        /> : null
                    }

                case 'excludedUntilDate':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.excludedUntilDate?.value && b.excludedUntilDate?.value
                                ? a.excludedUntilDate.value.toString().localeCompare(b.excludedUntilDate.value.toString())
                                : 0,
   
                        key: field.name,
                        render: (value, record, index) => value !== null ?
                           <SizedDateDataInput
                                value={record[field.name].value}
                                fieldName={field.name}
                                label={undefined}
                                changeData={value => onChangeDate(value, field.name, record.rowIndex)}
                                readOnly={isReadonly !== undefined ? isReadonly : false}
                                isHidden={false}
                            /> : null
                    }

                case  'worksRetainedUntil':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.worksRetainedUntil?.value && b.worksRetainedUntil?.value
                                ? a.worksRetainedUntil.value.localeCompare(b.worksRetainedUntil.value)
                                : 0,
                        key: field.name,
                        render: (value, record, index) => value !== null ?
                            <DropdownDataInput
                                value={record[field.name].value}
                                fieldName={field.name}
                                options={options}
                                changeData={value => lookupOptionsAndOnChangeFunctions['worksRetainedUntil'].onChangeValue(value, field.name, record.rowIndex)}
                                allowNull={true}
                                useComboBoxAsMenuWidth={false}
                                isHidden={false}
                                readOnly={isReadonly !== undefined ? isReadonly : undefined}
                            /> : null
                    }

                case 'workRetentionEndDate':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.workRetentionEndDate?.value && b.workRetentionEndDate?.value
                                ? a.workRetentionEndDate.value.toString().localeCompare(b.workRetentionEndDate.value.toString())
                                : 0,
                        key: field.name,
                        render: (value, record, index) => value !== null ?
                            <SizedDateDataInput
                                value={record[field.name].value}
                                fieldName={field.name}
                                label={undefined}
                                changeData={value => onChangeDate(value, field.name, record.rowIndex)}
                                readOnly={isReadonly !== undefined ? isReadonly : false}
                                isHidden={false}
                            /> : null
                    }

                case 'useDefaultCollection':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.useDefaultCollection?.value && b.useDefaultCollection?.value
                                ? a.useDefaultCollection.value.localeCompare(b.useDefaultCollection.value)
                                : 0,
                        key: field.name,
                        render: (value, record, index) => value !== null ?
                            <DropdownDataInput
                                value={record[field.name].value}
                                fieldName={field.name}
                                options={options}
                                changeData={value => lookupOptionsAndOnChangeFunctions['useDefaultCollection'].onChangeValue(value, field.name, record.rowIndex)}
                                allowNull={true}
                                useComboBoxAsMenuWidth={false}
                                isHidden={false}
                                readOnly={isReadonly !== undefined ? isReadonly : undefined}
                            /> : null
                    }

                case 'workCollectionUntil':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.workCollectionUntil?.value && b.workCollectionUntil?.value
                                ? a.workCollectionUntil.value.localeCompare(b.workCollectionUntil.value)
                                : 0,
                        key: field.name,
                        render: (value, record, index) => value !== null ?
                            <DropdownDataInput
                                value={record[field.name].value}
                                fieldName={field.name}
                                options={options}
                                changeData={value =>  lookupOptionsAndOnChangeFunctions['workCollectionUntil'].onChangeValue(value, field.name, record.rowIndex)}
                                allowNull={true}
                                useComboBoxAsMenuWidth={false}
                                isHidden={false}
                                readOnly={isReadonly !== undefined ? isReadonly : undefined}
                            /> : null
                    }

                case 'workCollectionEndDate':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        sorter: (a, b) =>
                            a.workCollectionEndDate?.value && b.workCollectionEndDate?.value
                                ? a.workCollectionEndDate.value.toString().localeCompare(b.workCollectionEndDate.value.toString())
                                : 0,
                        key: field.name,
                           render: (value, record, index) => value !== null ?
                           <SizedDateDataInput
                               value={record[field.name].value}
                               fieldName={field.name}
                               label={undefined}
                               changeData={value => onChangeDate(value, field.name, record.rowIndex)}
                               readOnly={isReadonly !== undefined ? isReadonly : false}        
                               isHidden={false}
                           /> : null
                    }

                case 'remove_action':
                    return {
                        title: field.data,
                        dataIndex: field.name,
                        render: (value, record, index) => value !== null ?
                                            <IconTextButton
                                                icon={Delete20Regular}
                                                onClick={() => removeRow(record)}
                                                disabled={isReadonly !== undefined ? isReadonly : undefined}
                        /> : null
                    }
                    default:
                        return { title: field.data, dataIndex: field.name, key: field.name, sorter: (a, b) => (isNaN(a[field.name]) && a[field.name] != undefined) ? a[field.name].localeCompare(b[field.name]) : a[field.name] - b[field.name] }
                    };
        });
    
        return columns;
    };
    
    
    const handleExclusionChange = (newValue: string, record: IAgreementWorkDataItems) => {
        const updatedData = currentTableData.map(item => {
            if (item.workNumber === record.workNumber) {
                return { ...item, exclusionUntil: newValue };
            }
            return item;
        });
        setCurrentTableData(updatedData);
        if (props.changeData) {
            props.changeData(updatedData, 'exclusionUntil');
        }
    };
    
    const columns = getColumns();

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: IAgreementWorkDataItems[]) => {
            setSelectedRows(selectedRows);
        }
    };

    const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
        if (type === 'prev') {
            return <div className="pageNumberButton">Previous</div>;
        }
        if (type === 'next') {
            return <div className="pageNumberButton">Next</div>;
        }
        return originalElement;
    };

    
    return (
        <div className="tableContainer">
                   <Table
                                  columns={columns}
                                  rowKey={row => row.rowIndex}
                                  dataSource={filteredData}
                                  pagination={{
                                      defaultPageSize: props.resultsPerPage, 
                                      pageSizeOptions: [10, 25, 50, 100,250, 500,1000],
                                      showSizeChanger: true,
                                      
                                      position: ['bottomRight', 'topRight'], onChange(page, pageSize) {
                                        
                                          let isLastPage = page * pageSize === filteredData.length ? true : false;
                                          isLastPage = Math.ceil(filteredData.length / pageSize) == page ? true : false;
                                          const indexOfLastResult = page * props.resultsPerPage;
                                          const indexOfFirstResult = indexOfLastResult - props.resultsPerPage;
                                          const needMoreRows = indexOfLastResult <= filteredData.length ? true : false;
                                          props.updateContentsTable(indexOfFirstResult, indexOfLastResult, pageSize, page, 'agreementWorks');
                                           if (needMoreRows && isLastPage) {
                                               const nextPageToLoad = Math.floor(filteredData.length / 1000) + 1;
                                               setCurrentPage(nextPageToLoad);
                                               setPageSize(1000);
                                            const agreementData: IApplicableWorkSearchQuery = {
                                                agreementID: props.entityID,
                                                workNumber: "",
                                                page: nextPageToLoad,
                                                workName: "",
                                                pageSize: 1000,
                                                currentUserNameNumber: "",
                                                dataSource: props.entitySource
                                            };
                                            props.getApplicableWorkDetails(agreementData,false);
                                        }
                                      },
                                      current: currentPageNumberTable,
                                      defaultCurrent: props.currentPage,
                                      className: 'pageNumberDiv',
                                      total: filteredData.length,
                                      showTotal: (total) => `${total} Results`
                                  }}
                  
                                  size={'middle'}

                                  onChange={handleChange}
                                  className="parent-table"
                                  tableLayout={"auto"}
                              />
               </div>
    );
}